<div>
  <mat-sidenav-container [hasBackdrop]="false" (clickOutside)="sidenav.close()">
    <mat-sidenav
      class="sidebar"
      role="region"
      #sidenav
      [position]="'end'"
      [mode]="'over'"
      [fixedInViewport]="true"
      [fixedTopGap]="getSideNavTopGap()"
    >
      <ng-container *ngIf="sidebarData">
        <local-seo-listing-sidebar
          #listingSidebar
          (closed)="sidenav.close()"
          (upgrade)="OpenUpgradeDialog()"
          [data]="sidebarData"
          (retry)="retry()"
        ></local-seo-listing-sidebar>
      </ng-container>
    </mat-sidenav>
    <mat-sidenav-content>
      <va-filtered-mat-table
        [tableDataService]="listingSyncTableService"
        (cellEventEmitter)="handleCellEvent($event)"
        (rowClick)="handleRowClick($event)"
      ></va-filtered-mat-table>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
